module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAECAYAAABV5LW0AAAAU0lEQVQYV2NkIAIIzD2ey/j/f9H7v2xqDOkmvxmJ0MPAMP8+h+Cf5/cZGZiq3qVazGeUWXWMkxiNXz8yFv5nZEj4wPdYk1Fw9rH/xGiCq/nPGAMA3XcaKSaLmfIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shop-icon2.png
// module id = dyCf
// module chunks = 32